import handler from 'api/handler'

const prefix = '/admin/crm'

const methods = {
  getStatistics: args => handler({ method: 'get', url: `${prefix}/statistics`, args })
}

export default methods

